<template>
  <modal
    name="modal--select-store"
    transition="nice-modal-fade"
    :click-to-close="false"
    :width="350"
    :height="'auto'"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    class="py-10"
  >
    <div
      class="flex flex-col text-black h-full bg-white overflow-hidden w-full justify-between p-4"
    >
      <div class="w-full">
        <div class="text-center text-4xl mb-1 font-extralight tracking-tight">
          {{ title }}
        </div>
        <div
          v-if="subtitle"
          class="text-center text-2xl mb-6 font-extralight tracking-tight"
        >
          {{ subtitle }}
        </div>
        <div>
          <select
            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline focus:bg-white focus:border-gray-500"
            id="countingUnits"
            v-model="selection"
            @click.stop
          >
            <option v-for="i in list" :key="`${i}`" :value="i">
              {{ display(i) }}
            </option>
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
              />
            </svg>
          </div>
        </div>

        <div class="flex flex-row justify-between mt-3">
          <div class="button" @click="clickCancel">
            {{ cancel }}
          </div>
          <div
            class="button"
            :class="{ 'opacity-40 cursor-not-allowed': !canConfirm }"
            @click="canConfirm && clickConfirm()"
          >
            {{ confirm }}
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ModalSelectStore',
  data: function() {
    return {
      selection: null,
      list: [],
      display: null,
      currentStore: null
    }
  },
  computed: {
    canConfirm() {
      return this.selection !== null && this.selection !== this.currentStore
    }
  },
  props: {
    title: {
      type: String,
      default: 'Switch Store?'
    },
    subtitle: {
      type: String,
      default: null
    },
    cancel: {
      type: String,
      default: 'Cancel'
    },
    confirm: {
      type: String,
      default: 'Confirm'
    }
  },
  methods: {
    ...mapActions('config', ['setFabVisible']),
    ...mapActions(['switchStores']),
    clickCancel: function() {
      this.$emit('cancel')
      this.$modal.hide('modal--select-store')
    },
    // clickConfirm: async function() {
    //   this.$emit('confirm', {
    //     selection: this.selection
    //   })
    //   this.$modal.hide('modal--select-store')
    // },
    async clickConfirm() {
      this.$modal.show('loading')
      let select = this.selection
      this.$modal.hide('modal--select-store')
      //console.log('switching stores', this.$router.currentRoute.name)
      await this.switchStores(select).then(() => {
        // console.log('store switched', this.$router.currentRoute.name)
        // this.$router.currentRoute.name !== 'dashboard' &&
        //   this.$router.replace({ name: 'dashboard' }) // push?
      })
      //console.log('done switching stores?', this.$router.currentRoute.name)
    },
    beforeOpen(event) {
      this.list = event.params && event.params.list ? event.params.list : null
      if (!this.list) {
        event.stop()
      } else {
        this.currentStore = event.params.currentStore || null
        this.selection = this.currentStore || this.list[0]
        this.display = event.params.display ? event.params.display : e => e
      }
      this.setFabVisible(false)
    },
    beforeClose() {
      this.list = []
      this.display = null
      this.selection = null
      this.currentStore = null
      this.setFabVisible(true)
    }
  }
}
</script>
